import React from "react";
import "./table.scss";
import { PropTypes } from "prop-types";
export const NewTable = ({
  data,
  cols,
  legend
}) => {
  return React.createElement("div", {
    className: "table-datosContainer"
  }, React.createElement("div", {
    className: "table-datosScroll"
  }, React.createElement("div", {
    className: "table-wrapper"
  }, data.length !== 0 && React.createElement("table", null, React.createElement("thead", null, React.createElement("tr", null, cols.map(col => React.createElement("th", {
    key: col.label,
    className: col.classHead
  }, col.label)))), React.createElement("tbody", null, data.filter(item => {
    return true;
  }) // TODO REVISAR
  .map(item => React.createElement("tr", {
    key: item.name || item.partyAcronym || item.id
  }, cols.map(col => React.createElement("td", {
    key: "".concat(col.label, "-").concat(item.name),
    className: col.classBody
  }, React.createElement("span", {
    style: col.showColor ? {
      borderLeft: "10px solid ".concat(item.partyColor)
    } : {}
  }, React.createElement("span", {
    className: "partido"
  }, col.map ? col.map(item[col.key]) : item[col.key])))))))))), legend && React.createElement("p", {
    className: "table-datosLegend"
  }, legend));
};
NewTable.propTypes = {
  data: PropTypes.array.isRequired,
  cols: PropTypes.array,
  legend: PropTypes.string
};
NewTable.defaultProps = {
  legend: "",
  cols: [{
    label: "",
    key: "partyAcronym",
    classHead: "partido",
    classBody: "dato-nombre-partido",
    showColor: true
  }, {
    label: "% Votos",
    key: "votesPercent",
    classHead: "porcentaje",
    classBody: "dato-escanos",
    map: data => Number(data).toLocaleString("es")
  }, {
    label: "Votos",
    key: "votes",
    classHead: "porcentaje",
    classBody: "dato-escanos",
    map: data => Number(data).toLocaleString("es")
  }]
};
export default NewTable;